// Typed client for /api/video (case footage analysis).
import axios from "axios";
import { CallParticipant, FootageFinding, VideoAnalysisMetadata, VideoEvent } from "../../db/schema";
import { NormalizedTranscript } from "../../components/Investigations/api";

const base = "/api/video";

export type CaseFootageDetail = {
  fileId: string;
  fileName: string | null;
  url: string | null;
  transcript: NormalizedTranscript | null;
  participants: CallParticipant[];
  video: Omit<VideoAnalysisMetadata, "triage"> & {
    findings?: FootageFinding[];
    checkedAt?: string;
    minutes: { minute: number; scene: string; camera_state: string; activity: "none" | "low" | "high" }[];
    segments: { start_ms: number; end_ms: number; reason: string; priority: number }[];
    idle: { start_ms: number; end_ms: number }[];
    frames: number[];
    motion: number[];
    events: VideoEvent[];
  };
};

export const videoApi = {
  detail: (caseId: string, fileId: string) => axios.get<CaseFootageDetail>(`${base}/cases/${caseId}/files/${fileId}`).then((r) => r.data),
  proxyUrl: (caseId: string, fileId: string) => axios.get<{ url: string }>(`${base}/cases/${caseId}/files/${fileId}/proxy-url`).then((r) => r.data.url),
  frameUrl: (caseId: string, fileId: string, t: number) => `${base}/cases/${caseId}/files/${fileId}/frame?t=${t}`,
  analyze: (caseId: string, fileId: string, body: { mode?: "verify" | "enrich"; analyzeAll?: boolean } = {}) =>
    axios.post(`${base}/cases/${caseId}/files/${fileId}/analyze`, body),
  setStills: (caseId: string, fileId: string, stills: number[]) => axios.post<{ stills: number[] }>(`${base}/cases/${caseId}/files/${fileId}/stills`, { stills }).then((r) => r.data),
};
